import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import LocationDataGrid from '../LocationDataGrid';
import LocationList from '../LocationList';
import type { Filter } from '#/common/components/DataGrid';

interface LocationsProps {
  permanentFilters?: Filter[];
}

const Locations: React.FC<LocationsProps> = ({ permanentFilters }) => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <LocationDataGrid permanentFilters={permanentFilters} />
      </If>
      <If condition={!isDesktop}>
        <LocationList />
      </If>
    </>
  );
};

export default React.memo(Locations);
